import { render } from "./WritingZonesAtAnnotTrans.vue?vue&type=template&id=130ebc3a&scoped=true"
import script from "./WritingZonesAtAnnotTrans.vue?vue&type=script&lang=js"
export * from "./WritingZonesAtAnnotTrans.vue?vue&type=script&lang=js"

import "./WritingZonesAtAnnotTrans.vue?vue&type=style&index=0&id=130ebc3a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130ebc3a"]])

export default __exports__